import React from 'react';
import ContentEditor from './ContentEditor';
import SpecialCard from '../../components/SpecialCard';

export const AdminPresidents = () => (
  <ContentEditor
    name="presidents" kicker="Kurumsal" title="Başkanlarımız"
    schema={[
      { key: 'name', label: 'Ad Soyad', type: 'text', required: true },
      { key: 'period', label: 'Dönem (ör. 1992-2017)', type: 'text' },
      { key: 'years', label: 'Görev süresi (yıl)', type: 'number' },
      { key: 'image', label: 'Fotoğraf', type: 'image' },
      { key: 'role', label: 'Unvan', type: 'text' },
      { key: 'bio', label: 'Biyografi', type: 'textarea' },
      { key: 'quote', label: 'Alıntı', type: 'textarea' },
    ]}
    defaultData={{ name: '', period: '', years: 0, image: '', role: '', bio: '', quote: '' }}
  />
);

export const AdminBoard = () => (
  <ContentEditor
    name="board_members" kicker="Kurumsal" title="Yönetim / Denetim / Danışma Kurulları"
    schema={[
      { key: 'name', label: 'Ad Soyad', type: 'text', required: true },
      { key: 'role', label: 'Görev', type: 'text', help: 'Başkan, Üye, Sekreter, Denetim Kurulu Başkanı vs.' },
      { key: 'short', label: 'Kısa Etiket (ör: 1. BŞK. YRD.)', type: 'text' },
      { key: 'image', label: 'Fotoğraf', type: 'image' },
      { key: 'group', label: 'Grup', type: 'text', help: 'executive · members · audit · advisory', suggestions: ['executive', 'members', 'audit', 'advisory'] },
    ]}
    defaultData={{ name: '', role: 'Üye', short: 'ÜYE', image: '', group: 'members' }}
  />
);

export const AdminEvents = () => (
  <ContentEditor
    name="events" kicker="Etkinlikler" title="Sosyal & Kültürel Etkinlikler"
    schema={[
      { key: 'title', label: 'Başlık', type: 'text', required: true, placeholder: 'Örn: 33. Yıl Kuruluş Gecesi' },
      { key: 'category', label: 'Kategori', type: 'text', placeholder: 'Tiyatro Ödülü, Seminer, Gala...', suggestions: ['Tiyatro Ödülü', 'Gençlik Çalıştayı', 'Seminer', 'Buluşma', 'Konser', 'Kampanya', 'Öğrenci Buluşması', 'Gala', 'Atölye', 'Mezuniyet', 'Sosyal Sorumluluk', 'Şenlik', 'Okuma', 'Yeni Yıl', 'Gezi & Söyleşi', 'Söyleşi', 'Kitap Fuarı', 'Milli Bayram', 'Kariyer', 'Robotik', 'Kültür Saati', 'Kuruluş Yıldönümü', 'Felsefe', 'Ödül Töreni'] },
      { key: 'year', label: 'Yıl', type: 'text', placeholder: '2026', suggestions: ['2026', '2025', '2024', '2023'] },
      { key: 'date', label: 'Tarih', type: 'text', placeholder: 'Mayıs 2026' },
      { key: 'image', label: 'Kapak Görseli', type: 'image' },
      { key: 'excerpt', label: 'Özet (kartta görünen)', type: 'textarea', placeholder: 'Etkinlik hakkında 1-2 cümle...' },
      { key: 'content', label: 'Detay İçeriği', type: 'richtext', placeholder: 'Etkinliğin tam anlatımı, konuşmacılar, galeri, izlenimler...' },
      { key: 'featured', label: 'Öne Çıkan? (sayfa üstündeki büyük kart olur)', type: 'bool' },
    ]}
    defaultData={{ title: '', category: '', year: '2026', date: '', image: '', excerpt: '', content: '', featured: false }}
  />
);

export const AdminPress = () => (
  <ContentEditor
    name="press_clips" kicker="Medya" title="Basın Kesitleri & Videolar"
    schema={[
      { key: 'title', label: 'Başlık', type: 'text', required: true },
      { key: 'outlet', label: 'Kaynak', type: 'text', help: 'Sabah, Hello!, CNN Türk vs.' },
      { key: 'year', label: 'Yıl', type: 'text' },
      { key: 'image', label: 'Görsel/Thumbnail', type: 'image' },
      { key: 'video_id', label: 'YouTube ID (varsa)', type: 'text', help: 'Video için YouTube video ID' },
      { key: 'type', label: 'Tip (image|video)', type: 'text' },
    ]}
    defaultData={{ title: '', outlet: '', year: '2026', image: '', video_id: '', type: 'image' }}
  />
);

export const AdminBankAccounts = () => (
  <ContentEditor
    name="bank_accounts" kicker="Bağış Kanalları" title="Banka Hesapları (IBAN)"
    schema={[
      { key: 'bank', label: 'Banka Adı', type: 'text', required: true, help: 'Örn: Türkiye İş Bankası' },
      { key: 'branch', label: 'Şube', type: 'text', help: 'Örn: Şişli Şubesi' },
      { key: 'currency', label: 'Para Birimi', type: 'text', help: 'TRY, USD, EUR' },
      { key: 'iban', label: 'IBAN', type: 'text', required: true },
      { key: 'account_holder', label: 'Hesap Sahibi (opsiyonel)', type: 'text' },
      { key: 'swift', label: 'SWIFT Kodu (uluslararası için)', type: 'text' },
    ]}
    defaultData={{ bank: '', branch: '', currency: 'TRY', iban: '', account_holder: '', swift: '' }}
  />
);

export const AdminSponsors = () => (
  <ContentEditor
    name="sponsors" kicker="Destekçilerimiz" title="Kurumsal Destekçiler"
    schema={[
      { key: 'name', label: 'Kurum Adı', type: 'text', required: true, help: 'Örn: Koç Holding' },
      { key: 'logo', label: 'Logo Görseli (opsiyonel)', type: 'image' },
      { key: 'website', label: 'Web Sitesi (opsiyonel)', type: 'text', placeholder: 'https://senpilic.com', help: 'Dolu ise, karta / logoya tıklayınca yeni sekmede bu adrese gider.' },
      { key: 'description', label: 'Kısa Açıklama (opsiyonel)', type: 'text' },
    ]}
    defaultData={{ name: '', logo: '', website: '', description: '' }}
  />
);

export const AdminPublications = () => (
  <ContentEditor
    name="publications" kicker="Yayınlar" title="Kitaplar & Dergiler"
    schema={[
      { key: 'title', label: 'Başlık', type: 'text', required: true },
      { key: 'type', label: 'Tip (kitap | dergi | rapor)', type: 'text', help: 'kitap · dergi · rapor', suggestions: ['kitap', 'dergi', 'rapor'] },
      { key: 'author', label: 'Yazar / Editör', type: 'text' },
      { key: 'year', label: 'Yıl', type: 'text' },
      { key: 'issue', label: 'Sayı (dergi için)', type: 'text', help: 'Örn: "Sayı 12"' },
      { key: 'cover', label: 'Kapak Görseli', type: 'image' },
      { key: 'pdf_url', label: 'PDF Dosyası (yükle veya URL yapıştır)', type: 'file', accept: 'application/pdf,.pdf', uploadLabel: 'PDF Yükle' },
      { key: 'pages', label: 'Sayfa Sayısı', type: 'text' },
      { key: 'description', label: 'Açıklama', type: 'textarea' },
    ]}
    defaultData={{ title: '', type: 'kitap', author: '', year: '2026', issue: '', cover: '', pdf_url: '', pages: '', description: '' }}
  />
);

export const AdminDonationTypes = () => (
  <ContentEditor
    name="donation_types" kicker="Bağışlar" title="Bağış Türleri"
    schema={[
      { key: 'title', label: 'Başlık', type: 'text', required: true, placeholder: 'Örn: Genel Bağış' },
      { key: 'kicker', label: 'Üst Etiket', type: 'text', placeholder: 'Serbest Kullanım, Aylık Düzenli...' },
      { key: 'slug', label: 'URL Slug (opsiyonel)', type: 'text', placeholder: 'genel, ozel-gun, proje', help: 'Boş bırakılırsa başlıktan otomatik üretilir.' },
      { key: 'description', label: 'Açıklama', type: 'textarea', placeholder: 'Bu bağış türü hakkında 1-2 cümle...' },
      { key: 'image', label: 'Kart Görseli', type: 'image' },
      { key: 'amounts', label: 'Önerilen Tutarlar (virgülle)', type: 'text', placeholder: '100, 250, 500, 1000', help: 'Kullanıcıya gösterilecek hızlı seçim tutarları' },
      { key: 'icon', label: 'İkon Anahtarı', type: 'text', placeholder: 'genel | ozelgun | proje | devre | egitim', suggestions: ['genel', 'ozelgun', 'proje', 'devre', 'egitim'] },
      { key: 'cta', label: 'Buton Metni', type: 'text', placeholder: 'Bağış Yap' },
      { key: 'link', label: 'Buton Linki', type: 'text', placeholder: '/bagis veya /bagis/ozel-gun' },
      { key: 'featured', label: 'Öne Çıkan? (büyük kart olur)', type: 'bool' },
    ]}
    defaultData={{ title: '', kicker: '', slug: '', description: '', image: '', amounts: '', icon: 'genel', cta: 'Bağış Yap', link: '/bagis', featured: false }}
  />
);

export const AdminKvkkDocs = () => (
  <ContentEditor
    name="kvkk_docs" kicker="KVKK" title="KVKK PDF Belgeleri"
    schema={[
      { key: 'title', label: 'Başlık', type: 'text', required: true, placeholder: 'KVKK Aydınlatma Metni' },
      { key: 'description', label: 'Kısa Açıklama', type: 'text', placeholder: 'PDF olarak indir · 2 sayfa' },
      { key: 'file', label: 'PDF Dosyası (yükle veya URL yapıştır)', type: 'file', accept: 'application/pdf,.pdf', uploadLabel: 'PDF Yükle' },
    ]}
    defaultData={{ title: '', description: 'PDF olarak indir', file: '' }}
  />
);

export const AdminTaxDocs = () => (
  <ContentEditor
    name="tax_docs" kicker="Vergi Muafiyeti" title="Vergi Belgeleri (PDF)"
    schema={[
      { key: 'title', label: 'Başlık', type: 'text', required: true, placeholder: 'Kamu Yararı Kararı Belgesi' },
      { key: 'description', label: 'Kısa Açıklama', type: 'text', placeholder: 'PDF olarak indir' },
      { key: 'file', label: 'PDF Dosyası (yükle veya URL yapıştır)', type: 'file', accept: 'application/pdf,.pdf', uploadLabel: 'PDF Yükle' },
    ]}
    defaultData={{ title: '', description: 'PDF olarak indir', file: '' }}
  />
);

export const AdminFAQ = () => (
  <ContentEditor
    name="faq" kicker="Burslar" title="Sıkça Sorulan Sorular"
    schema={[
      { key: 'question', label: 'Soru', type: 'text', required: true, placeholder: 'YEKÜV bursundan kimler yararlanabilir?' },
      { key: 'answer', label: 'Cevap', type: 'textarea', required: true, placeholder: 'Cevabı detaylı yazın...' },
      { key: 'scope', label: 'Gösterileceği Sayfa', type: 'text',
        help: 'all (tüm burs sayfaları) · universite · ilk-orta-lise · yenileme',
        suggestions: ['all', 'universite', 'ilk-orta-lise', 'yenileme'] },
    ]}
    defaultData={{ question: '', answer: '', scope: 'all' }}
  />
);

const VOLUNTEER_FIELD_SCHEMA = [
  { key: 'key', label: 'Alan Anahtarı (benzersiz, boşluksuz)', type: 'text', required: true, placeholder: 'ad_soyad, telefon, email...', help: 'Formda gizli id olarak kullanılır. Türkçe karakter ve boşluk kullanmayın (örn: "ad_soyad").' },
  { key: 'label', label: 'Görünen Başlık', type: 'text', required: true, placeholder: 'Ad Soyad' },
  { key: 'type', label: 'Alan Tipi', type: 'text', required: true, help: 'text · email · tel · textarea · select', suggestions: ['text', 'email', 'tel', 'textarea', 'select'] },
  { key: 'required', label: 'Zorunlu Alan mı?', type: 'bool' },
  { key: 'options', label: 'Seçenekler (sadece "select" tipi için)', type: 'textarea', placeholder: 'Eğitim Desteği, Mentorluk, Atölye, Diğer', help: 'Virgülle ayırın. Sadece "select" tipi alanlarda kullanılır.' },
  { key: 'col_span', label: 'Genişlik', type: 'text', help: 'half (yarım — yan yana 2 alan) · full (tam satır)', suggestions: ['half', 'full'] },
  { key: 'placeholder', label: 'Yer Tutucu Metin (opsiyonel)', type: 'text' },
];

export const AdminVolunteerBireysel = () => (
  <ContentEditor
    name="volunteer_fields_bireysel" kicker="Gönüllülük Formu" title="Bireysel Form Alanları"
    schema={VOLUNTEER_FIELD_SCHEMA}
    defaultData={{ key: '', label: '', type: 'text', required: false, options: '', col_span: 'half', placeholder: '' }}
  />
);

export const AdminVolunteerKurumsal = () => (
  <ContentEditor
    name="volunteer_fields_kurumsal" kicker="Gönüllülük Formu" title="Kurumsal Form Alanları"
    schema={VOLUNTEER_FIELD_SCHEMA}
    defaultData={{ key: '', label: '', type: 'text', required: false, options: '', col_span: 'half', placeholder: '' }}
  />
);

export const AdminMilestones = () => (
  <ContentEditor
    name="milestones" kicker="Tarihçe" title="Tarihçe Kilometre Taşları"
    schema={[
      { key: 'year', label: 'Yıl', type: 'text', required: true, placeholder: '1992, 2025 ...' },
      { key: 'title', label: 'Başlık', type: 'text', required: true, placeholder: 'Örn: Kamu Yararı, Yurt Açılışı ...' },
      { key: 'text', label: 'Açıklama', type: 'textarea', required: false, placeholder: 'Kısa bir cümleyle olayı özetleyin.' },
    ]}
    defaultData={{ year: '', title: '', text: '' }}
  />
);



export const AdminSpecialDays = () => (
  <ContentEditor
    name="special_days" kicker="Özel Gün Bağışı" title="Özel Günler"
    schema={[
      { key: 'title', label: 'Başlık (seçim ekranında)', type: 'text', required: true, placeholder: 'Doğum Günü, Anneler Günü...' },
      { key: 'emoji', label: 'Emoji (seçim ekranında)', type: 'text', required: true, placeholder: '🎂 🌸 💍 vb.' },
      { key: 'tone', label: 'Üst Etiket (kart üstünde küçük yazı)', type: 'text', placeholder: 'Kutlama, Anma, Aile, Meslek...', suggestions: ['Kutlama', 'Dilek', 'Anma', 'Doğum', 'Birliktelik', 'Sevgi', 'Başarı', 'Meslek', 'Yeni Yıl', 'Aile', 'Kampanya', 'Özel', 'Tebrik'] },
      { key: 'text', label: 'Seçim Açıklaması (seçim kartı altı)', type: 'textarea', placeholder: 'Bu özel gün için anlamlı bir açıklama...' },
      { key: 'card_image', label: 'Kart Görseli (gönderilen kartın üst yarısı)', type: 'image', help: 'Yüksek kaliteli, doğru oranlı bir görsel seçin. Resend ile alıcıya bu görsel gider.' },
      { key: 'card_title', label: 'Kart Başlığı (kart ortasında)', type: 'text', placeholder: 'Doğum Günün Kutlu Olsun' },
      { key: 'card_body', label: 'Kart Mesaj Şablonu', type: 'textarea', placeholder: 'doğum gününüzü kutlamak için', help: '"[Gönderen], [bu metin], sizin adınıza vakfımıza bağışta bulunarak bir YEKÜV Bursiyerinin eğitimine destek oldu." şeklinde bağlanır.' },
      { key: 'accent_color', label: 'Vurgu Rengi (HEX)', type: 'text', placeholder: '#C9A96E', help: 'Kart üzerindeki çizgi ve tutar rozeti rengi. Boş bırakılırsa altın rengi kullanılır.', suggestions: ['#C9A96E', '#0F1E4D', '#D46C8A', '#5FA08E', '#9BB7D4', '#3D4E8E', '#E56B8B', '#8FB996', '#6B7280'] },
    ]}
    defaultData={{ title: '', emoji: '🎁', tone: 'Kutlama', text: '', card_image: '', card_title: '', card_body: '', accent_color: '#C9A96E' }}
    preview={(data) => (
      <div style={{ transform: 'scale(0.85)', transformOrigin: 'top center' }}>
        <SpecialCard
          occasion={data}
          toName="Ayşe Yılmaz"
          fromName="Mehmet Öztürk"
          note="Tüm sevdiklerinize sağlık ve mutluluk dilerim."
          amount={500}
          id="PREVIEW-1234"
        />
      </div>
    )}
  />
);
